const energyFormatter = new Intl.NumberFormat('nl-BE', {
  maximumFractionDigits: 2,
});

function formatEnergyPerYear(value) {
  if (value === undefined || value === null) return '-';

  return `${energyFormatter.format(value / 1_000_000)} GWh/jaar`;
}

export { formatEnergyPerYear };
